/**
 * Impact fields: polarity and geographic scope.
 */
import React from "react";
import { PlusCircle, MinusCircle, X } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "ui/InputSelect";
import type { Scope } from "util/constants";

export interface ImpactFieldsProps {
  impactType: "impact_positive" | "impact_negative" | null;
  onImpactTypeChange: (v: "impact_positive" | "impact_negative" | null) => void;
  scope: Scope | "";
  onScopeChange: (v: Scope | "") => void;
}

const ImpactFields: React.FC<ImpactFieldsProps> = ({
  impactType,
  onImpactTypeChange,
  scope,
  onScopeChange,
}) => (
  <>
    <div className="space-y-2">
      <span className="block text-sm font-semibold">Impact type</span>
      <div className="flex gap-2 flex-wrap">
        <button
          type="button"
          onClick={() => onImpactTypeChange("impact_positive")}
          className={`px-2 py-1.5 text-xs rounded-full transition-colors flex items-center gap-1 ${
            impactType === "impact_positive"
              ? "bg-eoe-entity-impact-positive text-white font-semibold"
              : "btn-secondary font-normal"
          }`}
        >
          <PlusCircle className="size-4" aria-hidden />
          Positive
        </button>
        <button
          type="button"
          onClick={() => onImpactTypeChange("impact_negative")}
          className={`px-2 py-1.5 text-xs rounded-full transition-colors flex items-center gap-1 ${
            impactType === "impact_negative"
              ? "bg-eoe-entity-impact-negative text-white font-semibold"
              : "btn-secondary font-normal"
          }`}
        >
          <MinusCircle className="size-4" aria-hidden />
          Negative
        </button>
        {impactType ? (
          <button
            type="button"
            onClick={() => onImpactTypeChange(null)}
            className="px-2 py-1.5 text-xs rounded-full transition-colors flex items-center gap-1 btn-secondary font-normal"
          >
            <X className="size-4" aria-hidden />
            Clear
          </button>
        ) : null}
      </div>
    </div>

    <div className="space-y-2">
      <span className="block text-sm font-semibold">What is the scope of the impact?</span>
      <Select value={scope || undefined} onValueChange={(v) => onScopeChange(v as Scope)}>
        <SelectTrigger className="input-select px-3 py-2">
          <SelectValue placeholder="Scope" />
        </SelectTrigger>
        <SelectContent className="border border-eoe-border-main dark:border-eoe-dark-border-main">
          <SelectItem value="Local">Local</SelectItem>
          <SelectItem value="National">National</SelectItem>
          <SelectItem value="Global">Global</SelectItem>
        </SelectContent>
      </Select>
    </div>
  </>
);

export default ImpactFields;
